import React from 'react';
import { FadeIn } from './FadeIn';
import { Footprints, Angry, Gamepad2 } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <Footprints className="w-8 h-8 text-depto-amber" data-id="element-129" />,
    title: 'Paseos lineales',
    desc: 'Caminar por la vereda no agota el cerebro, solo el cuerpo.'
  }, {
    icon: <Angry className="w-8 h-8 text-depto-amber" data-id="element-130" />,
    title: 'Retarlo al llegar',
    desc: 'Tu perro no entiende por qué gritás por algo que pasó hace 4 horas; solo te tiene miedo.'
  }, {
    icon: <Gamepad2 className="w-8 h-8 text-depto-amber" data-id="element-131" />,
    title: 'Juguetes caros pero aburridos',
    desc: 'Si no sabe cómo usarlos, son solo pedazos de plástico tirados en el monoambiente.'
  }];
  return <section className="py-12 sm:py-24 px-5 sm:px-8 max-w-4xl mx-auto" data-id="element-132">
      <FadeIn data-id="element-133">
        <h2 className="text-2xl sm:text-4xl text-depto-brown mb-4 sm:mb-6 text-center" data-id="element-134">
          El problema es que te vendieron el mito del "paseo largo".
        </h2>
        <p className="text-base sm:text-lg text-depto-brown/80 mb-8 sm:mb-16 text-center max-w-3xl mx-auto leading-relaxed" data-id="element-135">
          Te dijeron que si lo sacabas a correr una hora a las 7 AM, el perro se
          iba a cansar. Pero lo que hiciste fue entrenar a un atleta: volvió a
          tu departamento con las pulsaciones a mil, los músculos calientes y la
          mente vacía. Por eso, a los 10 minutos de que cerraste la puerta,
          empezó a descargar su ansiedad con tus zapatillas o con el marco de la
          puerta.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-136">
        <h3 className="text-xl sm:text-3xl text-depto-brown mb-6 sm:mb-10 text-center" data-id="element-137">
          Por qué lo que probaste no funcionó:
        </h3>
        <div className="grid gap-6 sm:grid-cols-3" data-id="element-138">
          {painPoints.map((point, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-depto-brown/10 flex flex-col items-center text-center" data-id="element-139">
              <div className="bg-depto-beige p-4 rounded-full mb-4" data-id="element-140">
                {point.icon}
              </div>
              <h4 className="font-bold text-depto-brown text-lg mb-2" data-id="element-141">
                {point.title}
              </h4>
              <p className="text-depto-brown/70" data-id="element-142">{point.desc}</p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}